const SET_ERROR = "ERRORS/SET_ERROR";
const RESET = "ERRORS/RESET";

export { SET_ERROR, RESET };

export default {
  SET_ERROR,
  RESET,
};
